import { BaseCriteriaModel } from './base-criteria.model';
import { Optional } from 'typescript-optional';

export class CfpEngagementHdrQueryCriteriaClass extends BaseCriteriaModel {
  guids?: Optional<string[]> = Optional.empty();
  program_hdr_guids?: Optional<string[]> = Optional.empty();
  conglomerate_hdr_guids?: Optional<string[]> = Optional.empty();
  entity_hdr_guids?: Optional<string[]> = Optional.empty();
  entity_branch_guids?: Optional<string[]> = Optional.empty();
  search_word?: Optional<string> = Optional.empty();
  created_date_from?: Optional<string> = Optional.empty();
  created_date_to?: Optional<string> = Optional.empty();
  updated_date_from?: Optional<string> = Optional.empty();
  updated_date_to?: Optional<string> = Optional.empty();
}

export class CfpEngagementHdrCriteriaModelQuery {
  query = '';

  constructor(criteria: CfpEngagementHdrQueryCriteriaClass) {
    if (!criteria) {
      return;
    }

    criteria.guids.ifPresent(arr => arr.forEach(x => this.query += '&guids=' + x));
    criteria.program_hdr_guids.ifPresent(arr => arr.forEach(x => this.query += '&program_hdr_guids=' + x));
    criteria.conglomerate_hdr_guids.ifPresent(arr => arr.forEach(x => this.query += '&conglomerate_hdr_guids=' + x));
    criteria.entity_hdr_guids.ifPresent(arr => arr.forEach(x => this.query += '&entity_hdr_guids=' + x));
    criteria.entity_branch_guids.ifPresent(arr => arr.forEach(x => this.query += '&entity_branch_guids=' + x));
    this.query += criteria.search_word.filter(x => x !== '').map(x => '&search_word=' + x).orElse('');
    this.query += criteria.created_date_from.filter(x => x !== '').map(x => '&created_date_from=' + x).orElse('');
    this.query += criteria.created_date_to.filter(x => x !== '').map(x => '&created_date_to=' + x).orElse('');
    this.query += criteria.updated_date_from.filter(x => x !== '').map(x => '&updated_date_from=' + x).orElse('');
    this.query += criteria.updated_date_to.filter(x => x !== '').map(x => '&updated_date_to=' + x).orElse('');

    this.query += '&status=' + criteria.status;
    this.query += '&order=' + criteria.order;
    this.query += '&offset=' + criteria.offset + '&limit=' + criteria.limit;
  }
}
